import type { FormikValues } from 'formik'

import { getIn } from 'formik'

import type { TranslatedString } from '../../../../api/customQuestionnaire'
import type { QuestionDefinition } from '../../types'

export const getTranslation = (
	translations: TranslatedString,
	languageCode: string,
): string => {
	return translations[languageCode] || translations['en-GB'] || ''
}

export const activeSubquestions = (
	values: FormikValues | undefined,
	question: QuestionDefinition,
	fieldName?: string,
): QuestionDefinition[] | undefined => {
	const questionValue = getIn(values, fieldName ?? question.formFieldKey)

	const selectedOptions = question.options?.filter((x) => {
		if (questionValue == null) {
			return false
		}
		if (Array.isArray(questionValue)) {
			return questionValue.includes(x.value)
		}
		return x.value === questionValue
	})

	return selectedOptions?.flatMap((option) => option.subquestions || [])
}
